(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7457],{

/***/ 38903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95520);





const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  position: relative;
  border-radius: 0.5rem;
  background: #fff;
  height: ${(props) => props.height + 'px'};
  user-select: none;
`;
const StyledLogoLoading = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__/* .LogoLoading */ .h) `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;
const PreLoad = (_a) => {
    var { height, isLoading, hideLogo = false, logo } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["height", "isLoading", "hideLogo", "logo"]);
    if (!isLoading)
        return null;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, Object.assign({}, props, { height: height }), !hideLogo && react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLogoLoading, { logo: logo })));
};




/***/ }),

/***/ 49020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ EmptyState; }
});

// EXTERNAL MODULE: ../../.yarn/cache/tslib-npm-2.3.1-0e21e18015-de17a98d46.zip/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(91806);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/i18n.es.js
var i18n_es = __webpack_require__(8756);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(95889);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/mobile/EmptyState/search-no-result.es.js
var emptyImage = "https://shopfront-cdn.tekoapis.com/static/e536f0592aa3c8b1.png";



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/mobile/Flex/Flex.es.js
var Flex_es = __webpack_require__(3061);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/mobile/Text/Text.es.js
var Text_es = __webpack_require__(27893);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/mobile/EmptyState/EmptyState.es.js








const EmptyState = (_a) => {
    var { text } = _a, props = (0,tslib_es6/* __rest */._T)(_a, ["text"]);
    return (react.createElement(Flex_es/* Flex */.k, Object.assign({}, props, { flexDirection: "column", justifyContent: "center", alignItems: "center" }),
        react.createElement(LazyImage_es/* LazyImage */.w, { height: 128, width: 128, src: emptyImage }),
        react.createElement(Text_es/* Text */.x, { fontSize: 12, color: "#848788", marginTop: "24px", paddingX: "2rem" }, text || (0,i18n_es.t)('Không tìm thấy dữ liệu'))));
};




/***/ }),

/***/ 3061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Flex; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);





const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, (props) => `
  display: flex;
  ${props.justifyContent ? `justify-content: ${props.justifyContent};` : ''}
  ${props.alignItems ? `align-items: ${props.alignItems};` : ''}
  ${props.flexDirection ? `flex-direction: ${props.flexDirection};` : ''}
`);
const Flex = (_a) => {
    var { children, onClick } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["children", "onClick"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, Object.assign({ onClick: () => {
            if (onClick)
                onClick();
        } }, props), children));
};




/***/ }),

/***/ 27893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);




const getColor = (props) => {
    const { color, theme } = props;
    return ((color && (theme.brand[color] || theme.colors[color])) ||
        color ||
        theme.colors.dark);
};
const StyledText = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, (props) => {
    return `
    color: ${getColor(props)};
    font-weight: ${props.fontWeight || '400'};
    font-size: ${props.fontSize || 14}px;
    ${props.lineHeight ? ` line-height: ${props.lineHeight}px;` : ''}
    text-align: ${props.textAlign || 'left'};
    overflow: hidden;
    ${props.maxLines
        ? `text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${props.maxLines};`
        : ''}
    ${props.textTransform
        ? `
      text-transform: ${props.textTransform};
    `
        : ''}
  `;
});
const Text = (props) => {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledText, Object.assign({}, props));
};




/***/ }),

/***/ 98774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);





const StyledCard = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(({ theme, withPadding }) => `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
  ${withPadding ? 'padding: .5rem;' : ''}
`, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const CardHeader = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div ``;
const CardBody = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div ``;
const CardFooter = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div ``;
const Card = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
    var { children, header, footer, withPadding } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["children", "header", "footer", "withPadding"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, Object.assign({ ref: ref, withPadding: withPadding }, props),
        header && react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardHeader, { className: "card-header" }, header),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardBody, { className: "card-body" }, children),
        footer && react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardFooter, { className: "card-footer" }, footer)));
});
Card.displayName = 'Card';




/***/ }),

/***/ 58223:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/notification",
      function () {
        return __webpack_require__(34657);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ AccountLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var reflexbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98522);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97204);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1134);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43476);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11686);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84982);
/* harmony import */ var helpers_navigation_bar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20321);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91277);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36484);










function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-right: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 77vh;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var SideNav = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_5__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1316), __webpack_require__.e(1639), __webpack_require__.e(1303), __webpack_require__.e(1176), __webpack_require__.e(982), __webpack_require__.e(6861), __webpack_require__.e(6407), __webpack_require__.e(3211), __webpack_require__.e(8999), __webpack_require__.e(9754)]).then(__webpack_require__.bind(__webpack_require__, 68999)).then(function(mod) {
        return mod.SideNav;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68999)
            ];
        }
    }
});
var UserCard = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_5__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1316), __webpack_require__.e(1639), __webpack_require__.e(1303), __webpack_require__.e(1176), __webpack_require__.e(982), __webpack_require__.e(6861), __webpack_require__.e(6407), __webpack_require__.e(3211), __webpack_require__.e(8999), __webpack_require__.e(9754)]).then(__webpack_require__.bind(__webpack_require__, 68999)).then(function(mod) {
        return mod.UserCard;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68999)
            ];
        }
    }
});
var SideBar = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(_templateObject());
var StyledContainer = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .Container */ .W)(_templateObject1());
var AccountLayout = function(param) {
    var children = param.children, hiddenUserNavItems = param.hiddenUserNavItems;
    var user = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)().user;
    var ref = (0,_contexts__WEBPACK_IMPORTED_MODULE_8__/* .useTenantConfig */ .Wx)(), tenant = ref.tenant, notificationAppId = ref.notificationAppId;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var loyaltyMemberInfo = (0,hooks__WEBPACK_IMPORTED_MODULE_9__/* .useLoyalty */ .m)().loyaltyMemberInfo;
    var navItems = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,helpers_navigation_bar__WEBPACK_IMPORTED_MODULE_10__/* .getNavItems */ .r)({
            tenant: tenant,
            logged: !!(user === null || user === void 0 ? void 0 : user.userId),
            isLoyaltyMember: !!loyaltyMemberInfo,
            showNotificationItem: !!notificationAppId
        });
    }, [
        tenant,
        user
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledContainer, {
        mb: 3,
        mt: 3,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
            flexWrap: "wrap",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                    width: [
                        1,
                        1 / 3,
                        1 / 5
                    ],
                    children: !hiddenUserNavItems && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SideBar, {
                        children: [
                            !!(user === null || user === void 0 ? void 0 : user.userId) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserCard, {
                                name: (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.telephone),
                                picture: user === null || user === void 0 ? void 0 : user.avatar
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SideNav, {
                                activeHref: router.asPath || router.pathname,
                                navItems: navItems
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                    width: [
                        1,
                        2 / 3,
                        4 / 5
                    ],
                    children: children
                })
            ]
        })
    }));
};


/***/ }),

/***/ 53318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GN": function() { return /* binding */ ContainerLoading; },
  "gb": function() { return /* binding */ Loading; },
  "b7": function() { return /* binding */ PreLoad; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(97204);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/Common/PreLoad/PreLoad.es.js
var PreLoad_es = __webpack_require__(38903);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(43476);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(95889);
;// CONCATENATED MODULE: ./components/LogoLoading.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 80px;\n  height: 80px;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Wrapper = styled_es/* styled.div */.z.div(_templateObject());
var Logo = (0,styled_es/* styled */.z)(LazyImage_es/* LazyImage */.w)(_templateObject1());
var Spinner = styled_es/* styled.div */.z.div(function(param) {
    var theme = param.theme;
    return "\n    background: none;\n    @keyframes ldio-yuapljtmof {\n      0% {\n        transform: rotate(0deg);\n      }\n      50% {\n        transform: rotate(180deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n    .ldio-yuapljtmof  {\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      margin: auto;\n      animation: ldio-yuapljtmof 1s linear infinite;\n      width: 70px;\n      height: 70px;\n      border-radius: 50%;\n      box-shadow: 0 2px 0 0 ".concat(theme.brand.loading || '#1435c3', ";\n      box-sizing: content-box;\n    }\n");
});
var LogoLoading = function(_param) {
    var _logo = _param.logo, logo = _logo === void 0 ? '' : _logo, props = _objectWithoutProperties(_param, [
        "logo"
    ]);
    var size = 80;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpread({}, props, {
        children: [
            logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                width: size / 2,
                height: size / 2,
                src: logo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ldio-yuapljtmof"
                })
            })
        ]
    })));
};


;// CONCATENATED MODULE: ./components/Loading.tsx






function Loading_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Loading_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Loading_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Loading_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Loading_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Loading_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Loading_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Loading_templateObject() {
    var data = Loading_taggedTemplateLiteral([
        "\n  background: #fff2;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99999;\n"
    ]);
    Loading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Loading_templateObject1() {
    var data = Loading_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    Loading_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Loading_taggedTemplateLiteral([
        "\n  position: relative;\n  transition: opacity 0.3s;\n  &.loading-blur {\n    clear: both;\n    overflow: hidden;\n    opacity: 0.5;\n    user-select: none;\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = Loading_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  max-height: 400px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var StyledOverlay = styled_es/* styled.div */.z.div(Loading_templateObject());
var Loading = function(param) {
    var isLoading = param.isLoading, children = param.children;
    var ref;
    var logo = (0,GlobalDataContext/* useGlobalData */.U5)().logo;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOverlay, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLoading, {
                    logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
                })
            })
        ]
    }));
};
var PreLoad = function(_param) {
    var isLoading = _param.isLoading, props = Loading_objectWithoutProperties(_param, [
        "isLoading"
    ]);
    var ref;
    var logo = (0,GlobalDataContext/* useGlobalData */.U5)().logo;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(PreLoad_es/* PreLoad */.b, Loading_objectSpread({}, props, {
        isLoading: isLoading,
        logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
    })));
};

var ContainerLoadingWrapper = styled_es/* styled.div */.z.div(Loading_templateObject1());
var Container = styled_es/* styled.div */.z.div(_templateObject2());
var LoadingContainer = styled_es/* styled.div */.z.div(_templateObject3());
var ContainerLoading = function(param) {
    var children = param.children, style = param.style, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    var ref;
    var logo = (0,GlobalDataContext/* useGlobalData */.U5)().logo;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerLoadingWrapper, {
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingContainer, {
                style: style,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLoading, {
                    logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                className: isLoading ? 'loading-blur' : '',
                children: children
            })
        ]
    }));
};


/***/ }),

/***/ 88639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ MiniNotificationItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59802);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95889);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51748);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin-right: 16px;\n  width: 64px;\n  height: 64px;\n  border: 1px solid #e0e0e0;\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: unset;\n  border-radius: 50%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: calc(100% - 80px);\n  .message {\n    font-size: 14px;\n    color: #848788;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    line-height: 18px;\n    margin-top: 4px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #434657;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  color: #82869e;\n  line-height: 16px;\n  min-width: fit-content;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  color: #82869e;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-height: 20px;\n  margin-top: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
var Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(function(param) {
    var isRead = param.isRead;
    return "\n  padding: 16px;\n  display: flex;\n  cursor: pointer;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: ".concat(isRead ? 'white' : 'rgb(255, 242, 242)', ";\n");
});
var Avatar = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject());
var ProductImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject1());
var ContentWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject2());
var HeaderWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject3());
var TitleWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span */ .Z.span(_templateObject4());
var TimeWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span */ .Z.span(_templateObject5());
var MessageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span */ .Z.span(_templateObject6());
var MiniNotificationItem = function(props) {
    var date = new Date(props.time);
    var formatDate = "".concat(date.getDate(), "/").concat(date.getMonth() + 1, " - ").concat(date.getHours(), ":").concat(date.getMinutes());
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, _objectSpread({
        isRead: props.isRead
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Avatar, {
                children: !!props.avatar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductImageWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .LazyImage */ .w, {
                        src: props.avatar,
                        alt: "",
                        borderRadius: 50,
                        contain: true
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HeaderWrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleWrapper, {
                                children: props.title
                            }),
                            props.time && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TimeWrapper, {
                                children: formatDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MessageWrapper, {
                        dangerouslySetInnerHTML: {
                            __html: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_2__/* .htmlDecode */ .l_)(props.message)
                        }
                    })
                ]
            })
        ]
    })));
};


/***/ }),

/***/ 34657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ desktop_notification; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(17963);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(97204);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/molecules/Card/Card.es.js
var Card_es = __webpack_require__(98774);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_es = __webpack_require__(75068);
// EXTERNAL MODULE: ./components/Loading.tsx + 1 modules
var Loading = __webpack_require__(53318);
// EXTERNAL MODULE: ./components/Layout/AccountLayout.tsx
var AccountLayout = __webpack_require__(23268);
// EXTERNAL MODULE: ./components/desktop/organisms/MiniNotificationItem.tsx
var MiniNotificationItem = __webpack_require__(88639);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-b4cbbda601/0/cache/next-npm-12.0.9-6852d2b6ac-e01e3dbe8b.zip/node_modules/next/router.js
var next_router = __webpack_require__(11686);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/mobile/EmptyState/EmptyState.es.js + 1 modules
var EmptyState_es = __webpack_require__(49020);
// EXTERNAL MODULE: ./contexts/NotificationProvider.tsx
var NotificationProvider = __webpack_require__(63466);
;// CONCATENATED MODULE: ./components/desktop/pages/Notification.tsx










function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 0.75rem 0;\n  text-align: center;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: #82869e;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 2rem;\n  text-align: center;\n  margin: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
// TODO: bug/UX4BUYER-2904
// interface StyledTabProps extends TabProps, ThemeProps {}
// const StyledTabs = styled(Tabs)`
//   border-radius: 8px;
//   .tab-header {
//     border-bottom: 1px solid #e0e0e0;
//   }
// `;
// const StyledTab = styled(Tab)<StyledTabProps>`
//   background-color: #fff;
//   padding: 0.5rem 1rem;
//   color: #848788;
//   z-index: 1;
//   h5 {
//     font-size: 0.875rem;
//   }
//   &:first-of-type {
//     border-top-left-radius: 8px;
//   }
//   &.active {
//     color: ${(props) => props.theme.brand.primary};
//     position: relative;
//     &:before {
//       position: absolute;
//       content: '';
//       bottom: -1px;
//       left: 0;
//       width: 100%;
//       height: 2px;
//       background-color: ${(props) => props.theme.brand.primary};
//     }
//   }
// `;
var Message = styled_es/* styled.div */.z.div(_templateObject());
var CenteredWrapper = styled_es/* styled.div */.z.div(_templateObject1());
var NotificationPage = function() {
    var ref = (0,NotificationProvider/* useNotification */.lm)(), notifications = ref.notifications, promotions = ref.promotions, checkpoint = ref.checkpoint, loading = ref.loading, getNotifications = ref.getNotifications, handleNotificationClicked = ref.handleNotificationClicked, status = ref.status;
    var router = (0,next_router.useRouter)();
    var promoList = promotions.map(function(promotion) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(MiniNotificationItem/* MiniNotificationItem */.f, {
            title: promotion.label,
            message: promotion.subLabel,
            isRead: true,
            onClick: function() {
                if (promotion.url) {
                    router.push(promotion.url);
                }
            },
            avatar: promotion.imageUrl
        }, promotion.id);
    });
    var notiList = notifications.map(function(notification) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(MiniNotificationItem/* MiniNotificationItem */.f, {
            title: notification.title,
            message: notification.message,
            isRead: notification.is_read,
            onClick: function() {
                handleNotificationClicked(notification);
                if (notification.deepLink) {
                    router.push(notification.deepLink);
                } else if (notification.order) {
                    router.push({
                        pathname: "/account/orders/[orderId]",
                        query: {
                            orderId: notification.order.orderId
                        }
                    }, {
                        pathname: "/account/orders/".concat(notification.order.orderId)
                    });
                }
            },
            time: notification.created_at,
            avatar: !notification.order ? notification.image_url : notification.order.imageUrl
        }, notification.id));
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.gb, {
        isLoading: loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccountLayout/* AccountLayout */.p, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    children: (0,i18n.t)('Th\xf4ng b\xe1o của bạn')
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: status === NotificationProvider/* PageStatus.EMPTY */.ti.EMPTY && !loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CenteredWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState_es/* EmptyState */.u, {
                                text: (0,i18n.t)('Bạn chưa c\xf3 th\xf4ng b\xe1o mới')
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                promoList,
                                notiList,
                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                                    children: (0,i18n.t)('Đang tải th\xeam...')
                                }),
                                !loading && !checkpoint && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                                    children: (0,i18n.t)('Đ\xe3 hết th\xf4ng b\xe1o!')
                                }),
                                !loading && !!checkpoint && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                        variant: "primary",
                                        outline: true,
                                        size: "sm",
                                        onClick: function() {
                                            return getNotifications(checkpoint);
                                        },
                                        children: (0,i18n.t)('Tải th\xeam')
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var Notification = (NotificationPage);

;// CONCATENATED MODULE: ./tenants/_template/desktop/notification.tsx

/* harmony default export */ var notification = (Notification);

;// CONCATENATED MODULE: ./pages/default/desktop/notification.tsx
// AUTO GENERATED FILE. DO NOT EDIT.

/* harmony default export */ var desktop_notification = (notification);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8522,9037,3712,9774,2888,179], function() { return __webpack_exec__(58223); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);